import { ref, reactive, computed, useTemplateRef, type SetupContext, onBeforeUpdate } from 'vue'
import type { FormItemProps } from '../form-item'
import type { FormProps, FormEmits } from '../form'
import type { FormInstance, FormItemProp } from 'element-plus'

interface UseCollapseParams {
  isShowFold: boolean
  showFieldCount: number
  filterFormItemList: { value: FormItemProps[] }
}
export const useCollapse = (
  { isShowFold, showFieldCount, filterFormItemList }: UseCollapseParams,
  emit: SetupContext<FormEmits>['emit'],
) => {
  const open = ref(false)
  const toggleStatus = () => {
    open.value = !open.value
    emit('toggleStatus', open.value)
  }
  // 是否显示折叠按钮
  const isShowFoldBtn = computed(() => {
    return isShowFold && filterFormItemList.value.length > showFieldCount
  })
  //   展开收起隐藏formItem逻辑
  const isShowFormItem = (index: number) => {
    return index < showFieldCount || open.value || !isShowFoldBtn.value
  }
  return {
    open,
    toggleStatus,
    isShowFoldBtn,
    isShowFormItem,
  }
}

export const useForm = (props: FormProps) => {
  const elFormRef = useTemplateRef<FormInstance>('elFormRef')
  const filterFormItemList = computed(() => {
    return (props.formItemList || []).filter((item: FormItemProps) => {
      if ('show' in item) {
        return typeof item.show === 'function' ? item.show(item) : item.show
      } else if ('hide' in item) {
        return typeof item.hide === 'function' ? !item.hide(item) : !item.hide
      }
      return true
    })
  })
  // 校验
  const validate = () => {
    return elFormRef.value!.validate()
  }
  // 重置校验
  const resetFields = (props: FormItemProp) => {
    return elFormRef.value!.resetFields(props)
  }
  // 清理某个字段的表单验证信息
  const clearValidate = (props: FormItemProp) => {
    return elFormRef.value!.clearValidate(props)
  }
  // 存储form-item的ref
  const formItemRenderRefs = reactive(new Map())
  // 每次更新前清空，防止内存泄漏或引用过时
  onBeforeUpdate(() => {
    formItemRenderRefs.clear();
  });
  // 获取form-item渲染render的ref
  const getFormItemRenderRef = (refName: string) => {
    return formItemRenderRefs.get(refName)
  }
  // 注册form-item的ref
  const registerFormItemRenderRef = (refName: string, ref: any) => {
    if (refName && ref) {
      formItemRenderRefs.set(refName, ref)
    }
  }

  return {
    filterFormItemList,
    elFormRef,
    validate,
    resetFields,
    clearValidate,
    getFormItemRenderRef,
    registerFormItemRenderRef,
  }
}
